import styled, { createGlobalStyle } from 'styled-components';
import { Link } from 'react-router-dom';
import { mq } from '../../theme/mediaQueries';

// The authenticated app shell sets body { overflow: hidden } and scrolls an
// inner container. Public pages flow in the document body, so restore body
// scrolling while one is mounted (createGlobalStyle reverts on unmount).
export const PublicScrollUnlock = createGlobalStyle`
  body { overflow-y: auto; }
`;

export const StyledPublicRoot = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: var(--paper);
  color: var(--ink);
`;

export const StyledPublicHeader = styled.header`
  position: sticky;
  top: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 32px;
  background: color-mix(in srgb, var(--surface) 88%, transparent);
  backdrop-filter: saturate(140%) blur(8px);
  border-bottom: 1px solid var(--line);

  ${mq.ltSm} { padding: 14px 18px; }
`;

export const StyledPublicBack = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: var(--t-sm);
  font-weight: 600;
  color: var(--brand-green);
  text-decoration: none;

  &::before {
    content: '←';
    font-size: 15px;
    transition: transform 0.15s ease;
  }
  &:hover::before { transform: translateX(-3px); }

  [dir='rtl'] &::before { content: '→'; }
  [dir='rtl'] &:hover::before { transform: translateX(3px); }
`;

export const StyledPublicMain = styled.main`
  flex: 1;
  width: 100%;
  max-width: 880px;
  margin: 0 auto;
  padding: 56px 32px 72px;

  ${mq.ltSm} { padding: 36px 18px 56px; }
`;

export const StyledPublicFooter = styled.footer`
  border-top: 1px solid var(--line);
  background: var(--surface);
`;

export const StyledPublicFooterInner = styled.div`
  max-width: 880px;
  margin: 0 auto;
  padding: 22px 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  color: var(--muted);
  font-size: var(--t-xs);

  ${mq.ltSm} { padding: 18px; }
`;

export const StyledPublicFooterLinks = styled.nav`
  display: inline-flex;
  align-items: center;
  gap: 18px;

  a {
    color: var(--muted);
    text-decoration: none;
    font-weight: 500;
    &:hover { color: var(--ink); }
  }
`;
